/* ===========================================================================
   Offcanvas
   =========================================================================== */

import { $body } from '../settings/settings';

/**
 * [offCanvasFixed description]
 * @method offCanvasFixed
 * @return {[type]}       [description]
 */
export function offCanvasFixed() {

  $('.off-canvas').on('opened.zf.offcanvas', () => {
    $body.style.overflowY = 'hidden';
  }).on('closed.zf.offcanvas', () => {
    $body.style.overflowY = 'auto';
  });

}
